module.exports = __webpack_public_path__ + "img/BlinkArt_Spear1H_Medium.a0713d09.png";